import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Header';
import ProtectedRoute from '../ProtectedRoute';
import CgmAppLayout from './CgmAppLayout';
import './CgmAppLayout.css';

/**
 * Layout CGM : navbar + menu latéral fixe pour toutes les pages du module caisse.
 */
export default function CgmModuleLayoutOutlet() {
  const { pathname } = useLocation();
  const isFullWidthPage =
    pathname === '/clients' || pathname === '/dashboard' || pathname === '/admin/dashboard';
  /** Module facturation NH : navbar CGM uniquement, sans menu latéral caisse */
  const isNhModulePage = pathname === '/nh' || pathname.startsWith('/nh/');

  const pageContentClass = isNhModulePage
    ? 'app-page-content cgm-module-page-content cgm-module-page-content--nh'
    : isFullWidthPage
      ? 'app-page-content'
      : 'container-fluid app-page-content cgm-module-page-content';

  const main = (
    <div className={pageContentClass}>
      <Outlet />
    </div>
  );

  return (
    <ProtectedRoute>
      <div className="cgm-page-frame">
        <Header />
        {isNhModulePage ? (
          <div className="cgm-app-shell cgm-app-shell--no-sidebar">
            <div className="cgm-app-shell__main cgm-app-shell__main--full">{main}</div>
          </div>
        ) : (
          <CgmAppLayout>{main}</CgmAppLayout>
        )}
      </div>
    </ProtectedRoute>
  );
}
